import {parseInt as parseIntFp} from '@shared/helpers/string'

import {MerchantsState} from '@web/slices/merchants/slice'
import makeSlice from '@web/slices/merchants/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (_, {payload}) => {
            const {
                data: {merchantsByMerchantNo},
            } = payload
            const result: MerchantsState = {}

            Object.keys(merchantsByMerchantNo).forEach((merchantNoString) => {
                const merchants = merchantsByMerchantNo[merchantNoString]
                const merchantNo = parseIntFp(10, merchantNoString)
                if (merchants && merchantNo) {
                    result[merchantNo] = {
                        contactEmailAddress: null,
                        contactEmailAddressExposed: false,
                        merchantId: merchants.merchantId,
                        merchantUrl: '',
                        name: merchants.name,
                        personalCustomsCodeExposed: null,
                        unsupportedPaymentMethods: [],
                        relations: [],
                        isPointAccumulationAvailable: true,
                    }
                }
            })
            return result
        })
    },
})

export default slice.reducer
